module.exports = __webpack_public_path__ + "media/favicon/mstile-70x70-2d90b194f4eda75479b3712e7fc4150a.png";